module.exports = ".error-container {\r\n    width: 50%;\r\n    margin: 0 auto;\r\n    background-color: white;\r\n    height: calc(100vh - 150px);\r\n    padding-top: 5%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/error-page/error-page.component.css
// module id = 527
// module chunks = 2